import { vArray, type vOutput, vString } from '../validation/index.ts'

export const deleteContractedRatesSchema = vArray(vString())

export type DeleteContractedRatesDTO = vOutput<
  typeof deleteContractedRatesSchema
>
